import { render } from "./LatteTacchiato.vue?vue&type=template&id=41ccfc15"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/LatteTacchiato.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41ccfc15"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41ccfc15', __exports__)) {
    api.reload('41ccfc15', __exports__)
  }
  
  module.hot.accept("./LatteTacchiato.vue?vue&type=template&id=41ccfc15", () => {
    api.rerender('41ccfc15', render)
  })

}


export default __exports__